import { createTrackEvent } from 'utils/segment';
import * as t from './actionTypes';

const formatSearchQuery = (
  e: any,
  state: any,
  action: {
    page: number;
    pageSize: number;
    orderBy: string;
    sorting: any;
    templateType: string;
    messageMedium: string;
    filter: string;
  },
) => {
  const { page, pageSize, orderBy, sorting, templateType, messageMedium, filter } = action;
  return { page, pageSize, orderBy, sorting, templateType, messageMedium, filter };
};

export default {
  [t.FETCH_TEMPLATES_REQUEST]: createTrackEvent(
    'Template Wizard/Fetch Templates',
    [],
    formatSearchQuery,
  ),
  [t.CREATE_CAMPAIGN_TEMPLATE_REQUEST]: createTrackEvent('Template Wizard/Next step', ['Created']),
  [t.COPY_TEMPLATE_TO_CAMPAIGN_REQUEST]: createTrackEvent('Template Wizard/Next step', [
    'Assigned',
  ]),
};
